function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PowerBILogService from '@/apps/data-platform/services/power_bi_log/reports';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import { mapMutations, mapState } from 'vuex';
import tasks from '@/js/tasks';
import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { LIST_ROLES, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
export default {
  name: 'MonitoringMaintenance',
  components: {},
  data: function data() {
    return {
      isLoading: false,
      item: null,
      selected: {},
      DATA_OFFICE_COMPANY_CODE: '032',
      organizations: [],
      DIALOG_REPORT: 'DIALOG_REPORT',
      DIALOG_DELETE: 'DIALOG_DELETE',
      flag_create: true,
      valid: true,
      key_items: 0,
      items: [],
      report: {
        multiorg: false
      },
      readonly: false,
      update_hours: null,
      selectRols: _toConsumableArray(LIST_ROLES),
      keys: []
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    getOrganizations: function getOrganizations() {
      var _this = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success && response.code === 200) {
          _this.organizations = response.data.map(function (x) {
            return {
              name: x.alias,
              id: x.code
            };
          });
        }
      });
    },
    addItem: function addItem() {
      this.flag_create = true;
      this.report = {
        description: '',
        keys: [],
        link: '',
        maintenance: false,
        title: '',
        roles: [],
        organizations: []
      };
      this.openDialog(this.DIALOG_REPORT);
    },
    deleteItem: function deleteItem(item, modalName) {
      this.selected = item;
      this.openDialog(modalName);
    },
    editItem: function editItem(item) {
      this.report = _objectSpread({}, item);
      this.flag_create = false;
      this.openDialog(this.DIALOG_REPORT);
    },
    onAceptarDelete: function onAceptarDelete(valor) {
      var _this2 = this;
      if (valor) {
        MonitoringAccessService.deleteBillingMonitoring({
          document_id: this.selected.document_id
        }).then(function (response) {
          if (response.code === 200) {
            _this2.onCloseDialog(_this2.DIALOG_DELETE);
            tasks.toast.success('Reporte eliminado con éxito.');
            _this2.getInfo();
          }
        }).catch(function (err) {
          console.error(err);
        });
      } else {
        this.onCloseDialog(this.DIALOG_DELETE);
      }
    },
    getInfo: function getInfo() {
      var _this3 = this;
      this.setShowLoading(true);
      MonitoringAccessService.getBillingMonitoring({
        is_setting: true
      }).then(function (response) {
        _this3.items = response.data;
        _this3.key_items++;
        _this3.setShowLoading(false);
      }).catch(function (error) {
        console.error('Error:', error);
        _this3.setShowLoading(false);
      });
    },
    updateInfo: function updateInfo() {
      var _this4 = this;
      if (!this.$refs.form.validate()) return;
      MonitoringAccessService.postBillingMonitoring({
        data: this.report
      }).then(function (response) {
        if (response.success && response.code === 200) {
          tasks.toast.success(_this4.flag_create ? _this4.$t('frases.successfully_registered') : _this4.$t('frases  .successfully_updated'));
          _this4.onCloseDialog(_this4.DIALOG_REPORT);
          _this4.getInfo();
        }
      }).catch(function (error) {
        console.error('Error:', error);
      });
    }
  }),
  beforeMount: function beforeMount() {
    this.getOrganizations();
    this.getInfo();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'orgs'])), {}, {
    headers: function headers() {
      return [{
        text: this.$t('monitoring_billing.name'),
        align: 'start',
        value: 'title'
      }, {
        text: this.$t('monitoring_billing.description'),
        align: 'start',
        value: 'description'
      }, {
        text: this.$t('monitoring_billing.maintenance'),
        align: 'start',
        value: 'maintenance'
      }, {
        text: '',
        align: 'end',
        value: 'actions'
      }];
    },
    getClassTable: function getClassTable() {
      return 'col-sm-12';
    },
    rules: function rules() {
      var _this5 = this;
      return {
        general: [function (v) {
          return !!v || _this5.$t('rules.field');
        }]
      };
    }
  })
};